<template>
  <div
    v-if="row.DireccionColor"
    :style="{
      'border-color': `${row.DireccionColor} !important`,
      color: `${row.DireccionColor}`,
      border: 'solid',
      'border-width': '1px',
      'border-radius': '5px',
      'text-align': 'center'
    }"
  >
    {{ row.TipoSolicitud }}
  </div>
  <div v-else>
    {{ row.TipoSolicitud }}
  </div>
</template>

<script>
export default {
  name: "RequestType",
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },

  methods: {}
};
</script>
<style scoped>
.development {
  background-color: #409eff;
  text-align: center;
}
.ceo {
  background-color: #67c23a;
  text-align: center;
}
.projects {
  background-color: #e6a23c;
  text-align: center;
}
.commercial {
  background-color: #f56c6c;
  text-align: center;
}
.finance {
  background-color: #909399;
  text-align: center;
}
</style>
